import React, { useState, useEffect } from "react"

import { useStore } from "./context/store"

import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/Bundles/localization"

import { getDimensionData } from "@/components/ProductDetail/v3/ProductAccordionList/utils"

import BundleSpecsInstallationUI from "@/components/MultiFinshProductBundle/ui/BundleSpecsInstallationUI"
import BundleFeaturesUI from "@/components/MultiFinshProductBundle/ui/BundleFeaturesUI"
import BundleDimensionsUI from "@/components/MultiFinshProductBundle/ui/BundleDimensionsUI"

const BundleDetailsAccordian = props => {
  const { config = {}, productInfoBundle = {} } = props || {}
  const { state } = useStore()

  const {
    bundleItems = [],
    selectedProducts = [],
    pdpDetails: { sku = "" } = "",
  } = state

  const { t } = useTranslation("common")
  const {
    featuresLabel = "",
    dimensionsLabel = "",
    specsInstallationLabel = "",
  } = getTranslations(t)

  const [accordianData, setAccordianData] = useState({})

  const {
    bundleList = [],
    dimensionDataList = [],
    specFiles = [],
    installGuidesFiles = [],
  } = accordianData

  const selectedSkus = selectedProducts.map(item => {
    return item?.sku
  })

  const selectedSkusString = JSON.stringify(selectedSkus)

  // Filter Dimensions Spec and Install data

  useEffect(() => {
    const bundleList = []
    const dimensionDataList = []
    const specFiles = []
    const installGuidesFiles = []

    const getProductDimensionGata = item => {
      const {
        productDimensionAttributes: ProductDimensionAttributes,
        productDimensionAttributesValues: ProductDimensionAttributesValues,
        installGuidesFiles: installGuides = [],
        specPDFFileName = [],
        selectededSku = "",
        customerFacingSku = "",
        title = "",
      } = item

      const dimensionData =
        ProductDimensionAttributes.length &&
        ProductDimensionAttributesValues.length
          ? {
              ProductDimensionAttributes,
              ProductDimensionAttributesValues,
            }
          : {}

      const { dimensions = [] } = getDimensionData(dimensionData)

      if (dimensions.length) {
        dimensionDataList.push({
          sku: selectededSku,
          customerFacingSku,
          name: title,
          dimensionData: dimensions,
        })
      }

      installGuidesFiles.push(...installGuides)
      specFiles.push(...specPDFFileName)
    }

    selectedProducts.forEach(product => {
      const { products = [] } =
        bundleItems.find(item => item.name === product.name) || {}

      products.forEach(item => {
        if (item.masterSku === product.masterSku) {
          item["selectededSku"] = product.sku
          item["customerFacingSku"] = product.customerFacingSku
          bundleList.push(item)
          getProductDimensionGata(item)
        }
      })
    })

    setAccordianData({
      bundleList,
      dimensionDataList,
      installGuidesFiles,
      specFiles,
    })
  }, [selectedSkusString])

  return (
    <>
      {bundleList.length ? (
        <BundleFeaturesUI
          label={featuresLabel}
          data={bundleList}
          productInfoBundle={productInfoBundle}
        />
      ) : null}
      {dimensionDataList.length ? (
        <BundleDimensionsUI
          label={dimensionsLabel}
          data={dimensionDataList}
          config={config}
          productInfoBundle={productInfoBundle}
        />
      ) : null}
      {specFiles.length || installGuidesFiles.length ? (
        <BundleSpecsInstallationUI
          sku={sku}
          label={specsInstallationLabel}
          specFiles={specFiles}
          installGuidesFiles={installGuidesFiles}
          productInfoBundle={productInfoBundle}
        />
      ) : null}
    </>
  )
}

export default BundleDetailsAccordian
